import assignToThis from "../../helper/assignToThis";
import { ObjectOnly } from '@/classes/ObjectOnly';

export class GridComplexPricePeriod {

    public fromDate: Date | null = null;

    public toDate: Date | null = null;

    public monday: number[] | null = null;
    public tuesday: number[] | null = null;
    public wednesday: number[] | null = null;
    public thursday: number[] | null = null;
    public friday: number[] | null = null;
    public saturday: number[] | null = null;
    public sunday: number[] | null = null;

    public constructor(obj: ObjectOnly = {}) {
        assignToThis(this, obj);
    }

}
